// src/pages/consult/step1.js

import React from 'react';
import styles from './consult.module.css';

function Step1TipoPessoa({ onComplete }) {
    return (
        <div className={styles.consultPage}>
            <h4>Escolha o Tipo de Pessoa</h4>
            <button onClick={() => onComplete('Físico')}>Física</button>
            <button onClick={() => onComplete('Jurídico')}>Jurídica</button>
        </div>
    );
}

export default Step1TipoPessoa;
